import React from 'react';
import Cpf from './Cpf';
import DoisFa from './DoisFa';
import { connect } from 'react-redux';

export class Cpf2fa extends React.Component {


  state = {
    form: {cpf: ''}
  }

  handleChangeInterno = (valid,data) => {
    this.setState({form: {...this.state.form, ...data}})
    this.props.handleFormChange(valid,data);
  }


  render() {
    return (
      <>
        <DoisFa 
        handleNenhumaDasOpcoes={this.props.handleNaoEncontrado}
        isOpen={this.props.abre}
        onLogin={this.props.onLogin}
        onHide={this.props.handleFechou} 
        incluirParticipanteHandle={this.props.incluirParticipanteHandle}
        params={this.state.form} />
        <Cpf handleFormChange={this.handleChangeInterno} />
      </>
    );    
  }
}


const mapStateToProps = store => ({
  evento: store.eventoState.evento.item
});

export default connect(mapStateToProps)(Cpf2fa);
